import CheckmarkIconPath from "@ingka/ssr-icon/paths/checkmark";

export default CheckmarkIconPath;
